import React, { useState, useEffect } from 'react';
import Header from '../layouts/header/Header';
import Main from '../layouts/main/Main';
import Footer from '../layouts/footer/Footer';
import Form from '../ui/form/Form';
import ContextMessage from '../ui/context-message/ContextMessage';
import ScrollButton from '../ui/scroll-button/ScrollButton';
import './App.css';


export const FormContext = React.createContext(false);


function App() {
  const [show, setShow] = useState(false);
  const [showMsg, setShowMsg] = useState(false);
  const [menu, setMenu] = useState(false);
  const [type, setType] = useState('');
  const [backlight, setBacklight] = useState(true);
  const [current, setCurrent] = useState(false);
  const [os, setOs] = useState('other');

    const handleScroll = (event) => {
      let lineInet = document.querySelector('.background-line-internet')
      let linePhone = document.querySelector('.background-line-phone')
      let lineWifi = document.querySelector('.background-line-wifi')
      let lineVideo = document.querySelector('.background-line-video')
      if(lineInet !== undefined)
      {
        let pos = document.documentElement.scrollTop

        lineInet.style.transform = `translate3d(${ pos/ 100 }%, 0px, 0px)`
        linePhone.style.transform = `translate3d(${ pos / 100 }%, 0px, 0px)`
        lineWifi.style.transform = `translate3d(-${ pos / 100 }%, 0px, 0px)`
        lineVideo.style.transform = `translate3d(-${ pos / 100 }%, 0px, 0px)`
      }
      
    };

    window.addEventListener('scroll', handleScroll);
    
    useEffect(() => {
      if(navigator.userAgent.match(/android/i))
      {
        setOs('android');
      }
    }, [])

  return (
    <div className="App" onWheel={handleScroll} onClick={ () => setMenu( menu ? false : '' ) }>
      <ScrollButton />
      <FormContext.Provider value={ { show: show, setShow: setShow, 
                                      showMsg: showMsg, setShowMsg: setShowMsg, 
                                      menu: menu, setMenu: setMenu, 
                                      type: type, setType: setType, 
                                      backlight: backlight, setBacklight: setBacklight,
                                      current: current, setCurrent: setCurrent,
                                      os: os } }>
        <Header />
        <Main />
        { show ? <Form /> : null }
        { showMsg ? <ContextMessage /> : null}
        <Footer />
      </FormContext.Provider>
    </div>
  );
}

export default App;
